"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTinesSingleRouteToRouteV1 = void 0;
const Route_1 = require("../Route");
function convertTinesSingleRouteToRouteV1(route, pairs, input, output) {
    const pairHash = new Map();
    pairs.forEach((pair) => pairHash.set(pair.liquidityToken.address, pair));
    return new Route_1.RouteV1(route.legs.map((leg) => {
        const pair = pairHash.get(leg.poolAddress);
        if (pair === undefined) {
            throw new Error('Internal Error 119');
        }
        return pair;
    }), input, output);
}
exports.convertTinesSingleRouteToRouteV1 = convertTinesSingleRouteToRouteV1;
//# sourceMappingURL=convertTinesSingleRouteToRouteV1.js.map